import { Box, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

export function PtTaxId() {
  const { company } = useCurrentSession()

  const mainCountry = company.legalEntities.find((legalEntity) => legalEntity.main)?.country

  if (mainCountry !== 'pt') return null

  return (
    <Box gap="s4">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {i18n.t('settings.edit_company.tin')}
      </Text.Normal>
      <Box
        background="grey000White"
        padding="s16"
        borderRadius={{ all: 'abs008' }}
        border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
      >
        <Box padding="s6"></Box>
      </Box>
    </Box>
  )
}
